import { Injectable, inject, signal } from '@angular/core';
import { dsApi, dsDtos } from '@vectronic/openApi-admin';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceClassService {
  private deviceClassApi = inject(dsApi.DeviceClasses);
  constructor() {
    this.refresh();
  }

  deviceClasses = signal<dsDtos.DeviceClass[]>([]);

  deviceClasses$ = this.deviceClassApi.getDeviceClasses().pipe(shareReplay(1));

  refresh() {
    this.deviceClassApi.getDeviceClasses().subscribe((deviceClasses) => {
      this.deviceClasses.set(deviceClasses);
    });
  }
}
